export default {
  actInfo: null,
  overTime: false,
  is_Lottery: false,
  shareId: '', // 别人分享进来的
  cardInfo: null,
  showMusic: false,
  blessId: '' // 自己许愿生成的
}
